import type {PropsWithChildren} from 'react';
import {type ComponentProps, type FC} from 'react';

import {cn} from '@/modules/foundation/shared/tailwind';

type CheckboxProps = Omit<ComponentProps<'input'>, 'type'> & {
	labelProps?: ComponentProps<'label'>;
};

export const Checkbox: FC<PropsWithChildren<CheckboxProps>> = ({
	className: inputClassName,
	labelProps: {className: labelClassName, ...restLabelProps} = {},
	children,
	...restInputProps
}) => {
	return (
		<label
			className={cn([
				'inline-flex items-center gap-2 rounded-sm text-base font-semibold select-none lg:text-lg',
				'has-disabled:cursor-not-allowed',
				labelClassName,
			])}
			{...restLabelProps}
		>
			<input
				type="checkbox"
				className={cn([
					'rounded-sm border-2 border-neutral-600 bg-neutral-800',
					'size-5 lg:size-6',
					'diabled:cursor-not-allowed disabled:bg-neutral-700 disabled:text-neutral-400 disabled:checked:border-neutral-300 disabled:checked:bg-neutral-300',
					'checked:bg-primary checked:border-primary',
					'focus:ring-primary focus:ring-2 focus:ring-offset-2 focus:ring-offset-neutral-800 focus-visible:ring-yellow-400',
					inputClassName,
				])}
				{...restInputProps}
			/>
			{children}
		</label>
	);
};
